define('form-validation',['jquery', 'parsley'],

    function($) {

        'use strict';

        var pasteQueue = [],
            pasteRunner;

        // large number modulus function
        function modulo(divident, divisor) {
            var cDivident = '';
            var cRest = '';

            for (var i in divident) {
                if (i <= 24) {
                    var cChar = divident[i];
                    var cOperator = cRest + '' + cDivident + '' + cChar;

                    if (cOperator < parseInt(divisor)) {
                        cDivident += '' + cChar;
                    } else {
                        cRest = cOperator % divisor;
                        if (cRest == 0) {
                            cRest = '';
                        }
                        cDivident = '';
                    }
                }
            };

            cRest += '' + cDivident;
            if (cRest == '') {
                cRest = 0;
            }
            return cRest;
        }

        /**
         * Constrain the following fields to numbers
         *
         * business partner number
         * mobile
         * landline (phone, fax)
         * verification code
         * account number
         * premise number
         * PO box
         * contract value (move in)
         * iban
         */
        var numbersOnly = '[ data-parsley-bpn ], ' +
            '[ data-parsley-twonum ], ' +
            '[ data-parsley-mobile_number ], ' +
            '[ data-parsley-mobilenumber ], ' +
            '[ data-parsley-telephone_number ], ' +
            '[ data-parsley-verification_code ], ' +
            '[ data-parsley-account_number ], ' +
            '[ data-parsley-max_number ], ' +
            '[ data-parsley-maxnumber ], ' +
            '[ data-parsley-account_premise_number ], ' +
            '[ data-parsley-premise_number ], ' +
            '[ data-parsley-pobox ], ' +
            '[ data-parsley-grossfloorarea ], ' +
            '[ data-parsley-iban ], [ data-iban_confirm ], ' +
            '[ data-parsley-selectediban ], [ data-iban_confirm ], ' +
            '[ data-parsley-notification_number ], ' +
            '[ data-input-numbers ]',

            currencyInput = '[ data-parsley-currency ], ' +
            '[ data-parsley-contract_value ], ' +
            '[ data-parsley-contract-value ]';

        /**
         * Prevent pasting into the following fields
         *
         * IBAN
         * IBAN confirmation
         */
        $('[ data-parsley-iban ], ' + '[ data-parsley-selectediban ], ' +
            '[ data-iban_confirm ]').on('paste', function(ev) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
        });

        var FormValidation = function() {

                var formFieldErrorClassname = 'form-field__input--error',
                    formFieldWrapperClass = '.form-field__input-wrapper',
                    formFieldWrapperErrorClassname = 'form-field__input-wrapper--error',
                    formFieldWrapperSuccessClassname = 'form-field__input-wrapper--validated',
                    formFieldLabelErrorClassname = 'form-field__label--error',
                    formFieldLabelSuccessClassname = 'form-field__label--validated';


                /**
                 * Define parsley custom validators
                 */

                // DEWA Username
                window.Parsley.addValidator('username', {

                    requirementType: 'string',
                    validateString: function(value) {
                        var patt = new RegExp(/[^a-zA-Z0-9.@]/);
                        return (value.toString().length >= 6 && value.toString().length <= 75 && !patt.test(value));
                    }
                });

                // DEWA DewaUsername
                window.Parsley.addValidator('dewausername', {

                    requirementType: 'string',
                    validateString: function(value) {
                        var patt = new RegExp(/[^a-zA-Z0-9.]/);
                        return (value.toString().length >= 6 && value.toString().length <= 20 && !patt.test(value));
                    }
                });

                // BPN number
                window.Parsley.addValidator('bpn', {

                    requirementType: 'integer',
                    validateNumber: function(value) {
                        return value.toString().length === 8;

                    }
                });

                // BPN number
                window.Parsley.addValidator('twonum', {

                    requirementType: 'integer',
                    validateNumber: function(value) {

                        return value.toString().length === 10 || value.toString().length === 8;

                    }
                });

                // Account number
                window.Parsley.addValidator('estimate_number', {

                    requirementType: 'string',
                    validateString: function(value) {
                        return value.toString().length === 9;

                    }
                });

                // Account number
                window.Parsley.addValidator('doc_number', {

                    requirementType: 'string',
                    validateString: function(value) {
                        var patt = new RegExp(/[^a-zA-Z0-9]/);
                        return value.toString().length === 35 && !patt.test(value);
                    }
                });

                // Account number
                window.Parsley.addValidator('account_number', {

                    requirementType: 'string',
                    validateString: function(value) {
                        return value.toString().length === 10;

                    }
                });

                // Account number or premise number
                window.Parsley.addValidator('account_premise_number', {

                    requirementType: 'string',
                    validateString: function(value) {
                        return (value.toString().length >= 9 && value.toString().length <= 10);

                    }
                });

                // Account number
                window.Parsley.addValidator('premise_number', {

                    requirementType: 'string',
                    validateString: function(value) {
                        return value.toString().length === 9;
                    }

                });

                // Notication number
                window.Parsley.addValidator('notification_number', {

                    requirementType: 'string',
                    validateString: function(value) {
                        return value.toString().length === 9;

                    }
                });

                // Profanity filter 
                //window.Parsley.addValidator('profanity_filter', {
                //    requirementType: 'string',

                //    validateString: function(value) {

                //        var profanity = ['4r5e','5h1t','5hit','a55','anal','anus','ar5e','arrse','arse','ass','ass-fucker','asses','assfucker','assfukka','asshole','assholes','asswhole','a_s_s','b!tch','b00bs','b17ch','b1tch','ballbag','balls','ballsack','bastard','beastial','beastiality','bellend','bestial','bestiality','bi+ch','biatch','bitch','bitcher','bitchers','bitches','bitchin','bitching','bloody','blow job','blowjob','blowjobs','boiolas','bollock','bollok','boner','boob','boobs','booobs','boooobs','booooobs','booooooobs','breasts','buceta','bugger','bum','bunny fucker','butt','butthole','buttmuch','buttplug','c0ck','c0cksucker','carpet muncher','cawk','chink','cipa','cl1t','clit','clitoris','clits','cnut','cock','cock-sucker','cockface','cockhead','cockmunch','cockmuncher','cocks','cocksuck ','cocksucked ','cocksucker','cocksucking','cocksucks ','cocksuka','cocksukka','cok','cokmuncher','coksucka','coon','cox','crap','cum','cummer','cumming','cums','cumshot','cunilingus','cunillingus','cunnilingus','cunt','cuntlick ','cuntlicker ','cuntlicking ','cunts','cyalis','cyberfuc','cyberfuck ','cyberfucked ','cyberfucker','cyberfuckers','cyberfucking ','d1ck','damn','dick','dickhead','dildo','dildos','dink','dinks','dirsa','dlck','dog-fucker','doggin','dogging','donkeyribber','doosh','duche','dyke','ejaculate','ejaculated','ejaculates ','ejaculating ','ejaculatings','ejaculation','ejakulate','f u c k','f u c k e r','f4nny','fag','fagging','faggitt','faggot','faggs','fagot','fagots','fags','fanny','fannyflaps','fannyfucker','fanyy','fatass','fcuk','fcuker','fcuking','feck','fecker','felching','fellate','fellatio','fingerfuck ','fingerfucked ','fingerfucker ','fingerfuckers','fingerfucking ','fingerfucks ','fistfuck','fistfucked ','fistfucker ','fistfuckers ','fistfucking ','fistfuckings ','fistfucks ','flange','fook','fooker','fuck','fucka','fucked','fucker','fuckers','fuckhead','fuckheads','fuckin','fucking','fuckings','fuckingshitmotherfucker','fuckme ','fucks','fuckwhit','fuckwit','fudge packer','fudgepacker','fuk','fuker','fukker','fukkin','fuks','fukwhit','fukwit','fux','fux0r','f_u_c_k','gangbang','gangbanged ','gangbangs ','gaylord','gaysex','goatse','God','god-dam','god-damned','goddamn','goddamned','hardcoresex ','hell','heshe','hoar','hoare','hoer','homo','hore','horniest','horny','hotsex','jack-off ','jackoff','jap','jerk-off ','jism','jiz ','jizm ','jizz','kawk','knob','knobead','knobed','knobend','knobhead','knobjocky','knobjokey','kock','kondum','kondums','kum','kummer','kumming','kums','kunilingus','l3i+ch','l3itch','labia','lmfao','lust','lusting','m0f0','m0fo','m45terbate','ma5terb8','ma5terbate','masochist','master-bate','masterb8','masterbat*','masterbat3','masterbate','masterbation','masterbations','masturbate','mo-fo','mof0','mofo','mothafuck','mothafucka','mothafuckas','mothafuckaz','mothafucked ','mothafucker','mothafuckers','mothafuckin','mothafucking ','mothafuckings','mothafucks','mother fucker','motherfuck','motherfucked','motherfucker','motherfuckers','motherfuckin','motherfucking','motherfuckings','motherfuckka','motherfucks','muff','mutha','muthafecker','muthafuckker','muther','mutherfucker','n1gga','n1gger','nazi','nigg3r','nigg4h','nigga','niggah','niggas','niggaz','nigger','niggers ','nob','nob jokey','nobhead','nobjocky','nobjokey','numbnuts','nutsack','orgasim ','orgasims ','orgasm','orgasms ','p0rn','pawn','pecker','penis','penisfucker','phonesex','phuck','phuk','phuked','phuking','phukked','phukking','phuks','phuq','pigfucker','pimpis','piss','pissed','pisser','pissers','pisses ','pissflaps','pissin ','pissing','pissoff ','poop','porn','porno','pornography','pornos','prick','pricks ','pron','pube','pusse','pussi','pussies','pussy','pussys ','rectum','retard','rimjaw','rimming','s hit','s.o.b.','sadist','schlong','screwing','scroat','scrote','scrotum','semen','sex','sh!+','sh!t','sh1t','shag','shagger','shaggin','shagging','shemale','shi+','shit','shitdick','shite','shited','shitey','shitfuck','shitfull','shithead','shiting','shitings','shits','shitted','shitter','shitters ','shitting','shittings','shitty ','skank','slut','sluts','smegma','smut','snatch','son-of-a-bitch','spac','spunk','s_h_i_t','t1tt1e5','t1tties','teets','teez','testical','testicle','tit','titfuck','tits','titt','tittie5','tittiefucker','titties','tittyfuck','tittywank','titwank','tosser','turd','tw4t','twat','twathead','twatty','twunt','twunter','v14gra','v1gra','vagina','viagra','vulva','w00se','wang','wank','wanker','wanky','whoar','whore','willies','willy','xrated','xxx']
                //        var countwords = -1

                //        var words = value.split(" ");

                //        var foo = [];
                //            $.grep(profanity, function(el) {
                //                if ($.inArray(el, words) != -1) {
                //                    foo.push(el);
                //                }
                //            });

                //        if(foo.length > 0 ) {
                //            return false;
                //        }
                //        return true;
                //    }
                //});

                // Project generation subject
                window.Parsley.addValidator('project_generation_subject', {

                    requirementType: 'string',
                    validateString: function(value) {
                        return (value.toString().length > 0 && value.toString().length <= 125);
                    }
                });

                // Contract value
                window.Parsley.addValidator('contract_value', {

                    requirementType: 'integer',
                    validateString: function(value) {
                        return (value <= 999999999 && value > 0);

                    }
                });

                window.Parsley.addValidator('contract-value', {

                    requirementType: 'integer',
                    validateString: function(value) {
                        return (value <= 999999999 && value > 0);

                    }
                });

                // PO Box
                window.Parsley.addValidator('pobox', {
                    requirementType: 'integer',
                    validateString: function(value) {
                        var length = value.toString().length;
                        return length <= 6;
                    }
                });

                // PO Box
                window.Parsley.addValidator('grossfloorarea', {
                    requirementType: 'integer',
                    validateString: function(value) {
                        var length = value.toString().length;
                        return length <= 6;
                    }
                });


                // Verification code
                window.Parsley.addValidator('verification_code', {

                    requirementType: 'string',
                    validateString: function(value) {

                        var patt = new RegExp(/[^0-9]/);
                        return value.toString().length === 6 && !patt.test(value);

                    }
                });

                // Account number
                window.Parsley.addValidator('emiratesid', {

                    requirementType: 'integer',
                    validateNumber: function(value) {
                        var regex = value.toString().match(/^(?:784)\d{12}$/) !== null;
                        return value.toString().length === 15 && regex;

                    }
                });

                // Website
                window.Parsley.addValidator('website', {

                    requirementType: 'string',
                    validateString: function(value) {
                        var web = value.toString().match(/^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|^www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|^www\.[a-zA-Z0-9]\.[^\s]{2,}/) !== null;
                        //var patt = new RegExp(/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,}/);


                        return web; //!patt.test(value);
                    }

                });

                // RERA user ID
                window.Parsley.addValidator('rera_id', {

                    requirementType: 'string',
                    validateString: function(value) {

                        return value.toString().length > 5;

                    }
                });

                // IBAN
                window.Parsley.addValidator('iban', {
                    requirementType: 'string',
                    validateString: function(value) {
                        var prefix = '1014',
                            ibanTrans;

                        if (value.toString().length === 21) {
                            prefix += value.slice(0, 2);
                            ibanTrans = value.substr(2) + prefix;

                            return modulo(ibanTrans, 97) === '1';
                        }

                        return false;
                    }
                });

                // SELECTED-IBAN
                window.Parsley.addValidator('selectediban', {
                    requirementType: 'string',
                    validateString: function(value) {
                        var prefix = '1014',
                            ibanTrans;

                        var check = false,
                            bankcodes_array;

                        if (!($('.selectediban').attr('bankcodes') == undefined)) {
                            bankcodes_array = $('.selectediban').attr('bankcodes').split(",");
                        };

                        $(bankcodes_array).each(function() {
                            if (value.slice(2, 5) == this) {
                                check = true;
                            }
                        });

                        var check2 = ($('.selectediban').attr('bankcodes') == undefined || $('.selectediban').attr('bankcodes') == "");


                        if (value.toString().length === 21 && ((check && ($('.selectediban').attr('bankcodes').length != 0)) || check2)) {
                            prefix += value.slice(0, 2);
                            ibanTrans = value.substr(2) + prefix;

                            return modulo(ibanTrans, 97) === '1';
                        };

                        return false;
                    }
                });

                // Year
                window.Parsley.addValidator('year', {
                    requirementType: 'integer',
                    validateNumber: function(value) {
                        var d = new Date();
                        return value.toString().length === 4 && value <= d.getFullYear();
                    }
                });

                // Year
                window.Parsley.addValidator('max_partial_payment', {
                    requirementType: 'number',
                    validateNumber: function(value, requirement) {
                        return ((value <= 200000 + requirement) && value >= 0);
                    }
                });

                // password
                window.Parsley.addValidator('password', {

                    requirementType: 'string',
                    validateString: function(value, requirement) {

                        var matched = true,
                            usernameField = $(requirement)[0];

                        if (usernameField !== undefined && (usernameField.value === value)) {

                            matched = false;
                        } else {

                            matched = value.match(value.match((/^(?=.*\d)(?=.*[\D])[0-9\D]{8,}$/))) !== null;
                        }

                        return matched;
                    }
                });

                // DEWA password
                window.Parsley.addValidator('dewapassword', {

                    requirementType: 'string',
                    validateString: function(value) {

                        var matched = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$&+,:;=?@#|'<>.^*()%!_-])[A-Za-z\d$&+,:;=?@#|'<>.^*()%!_-]{8,}$/) !== null;

                        return matched;
                    }
                });

                //telephone number
                window.Parsley.addValidator('telephone_number', {
                    requirementType: 'string',
                    validateString: function(value) {
                        return value.match(/^(?:2|3|4|6|7|9)\d{7}$/) !== null;
                    }
                });

                //mobile number
                window.Parsley.addValidator('mobile_number', {
                    requirementType: 'string',
                    validateString: function(value) {
                        //return value.match( /^(?:50|52|55|56)\d{7}$/ ) !== null; comment by bharat                      

                        return ((value.match(/^(?:50|51|52|53|54|55|56|57|58|59|52|54|55|56)\d{7}$/) !== null) && !(/\b(1|0|5|9)\1+\b/).test(value.substring(2)));
                    }
                });

                //mobile number
                window.Parsley.addValidator('mobilenumber', {
                    requirementType: 'string',
                    validateString: function(value) {
                        //return value.match( /^(?:50|52|55|56)\d{7}$/ ) !== null; comment by bharat                      

                        return ((value.match(/^(?:50|51|52|53|54|55|56|57|58|59|52|54|55|56)\d{7}$/) !== null) && !(/\b(1|0|5|9)\1+\b/).test(value.substring(2)));
                    }
                });

                //email
                window.Parsley.addValidator('email', {
                    requirementType: 'string',
                    validateString: function(value) {
                        //return value.match( /^(?:50|52|55|56)\d{7}$/ ) !== null; comment by bharat                      

                        return !(/(?:dummy)/i).test(value);
                    }
                });

                //plot number
                window.Parsley.addValidator('plotnumber', {
                    requirementType: 'string',
                    validateString: function(value) {
                        //return value.match( /^(?:50|52|55|56)\d{7}$/ ) !== null; comment by bharat                      

                        return ((/^(?:(?![a-zA-Z\s^.]).)*$/).test(value) && (/^(?!-)(?!.*--)[0-9-]+/).test(value) && (/[0-9]/).test(value.substr(value.length - 1)));
                        //return (/^(?!-)(?!.*--)[0-9-]+(?<!-)$/).test(value);
                        //return (value.match(/(?<=^|)\d+(\-\d+)?(?=$|)/) !== null)
                    }
                });

                // currency value
                window.Parsley.addValidator('currency', {
                    requirementType: 'string',
                    validateString: function(value) {
                        return value.match(/^\d*(\.\d{1,3})?$/) !== null;
                    }
                });

                // name value
                window.Parsley.addValidator('name', {
                    requirementType: 'string',
                    validateString: function(value) {
                        return value.match(/^[a-zA-Z\s'-.]*$/) !== null;
                    }
                });

                // fullname value
                window.Parsley.addValidator('fullname', {
                    requirementType: 'string',
                    validateString: function(value) {
                        return (value.match(/^[^:;{}\[\]<>?\/+*&^%$#!()_="'|/~]*$/) !== null) && !(value.toString().match(/^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|^www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|^www\.[a-zA-Z0-9]\.[^\s]{2,}/) !== null) && !(value.toString().match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null);
                    }
                });

                // min and max bill total
                window.Parsley.addValidator('billtotalmax', {
                    requirementType: 'string',
                    validateString: function(value, max) {
                        var valFloat = parseFloat(value);

                        return valFloat <= max;
                    }
                });
                window.Parsley.addValidator('billtotalmin', {
                    requirementType: 'string',
                    validateString: function(value, min) {
                        var valFloat = parseFloat(value);

                        return valFloat > min;
                    }
                });

                /**
                 * Listen to parsley events
                 */


                window.Parsley.on('form:validate', function(form) {
                    if (!form.isValid()) {
                        for (var n = 0; n < form.fields.length; n++) {
                            if (form.fields[n].validationResult !== true) {
                                if (window.navigator.userAgent.match(/iphone|ipad/i)) {
                                    window.setTimeout(function() {
                                        $("html,body").animate({
                                            scrollTop: $(form.fields[n].$element[0]).offset().top
                                        });
                                    }, 0);
                                }
                                break;
                            }
                        }
                    }
                });


                window.Parsley.on('field:success', function() {

                    var type = this.$element.attr('type'),
                        nosymbol = this.$element.attr('required') === undefined && this.$element.val().length === 0;

                    this.$element.attr('aria-invalid', false);

                    if (nosymbol) {

                        this.$element.removeClass(formFieldErrorClassname);
                        this.$element.parents(formFieldWrapperClass).removeClass(formFieldWrapperErrorClassname);
                    } else {

                        if (type !== 'file') {

                            this.$element.removeClass(formFieldErrorClassname);
                            this.$element.parents(formFieldWrapperClass).removeClass(formFieldWrapperErrorClassname).addClass(formFieldWrapperSuccessClassname);
                            this.$element.closest('.form-field__label').removeClass(formFieldLabelErrorClassname).addClass(formFieldLabelSuccessClassname);
                        }

                    }

                });

                window.Parsley.on('field:error', function() {

                    var type = this.$element.attr('type');

                    this.$element.attr('aria-invalid', true);

                    if (type !== 'file' && type !== 'checkbox' && type !== 'radio') {

                        this.$element.addClass(formFieldErrorClassname);
                        this.$element.parents(formFieldWrapperClass).removeClass(formFieldWrapperSuccessClassname).addClass(formFieldWrapperErrorClassname);
                        this.$element.closest('.form-field__label').removeClass(formFieldLabelSuccessClassname).addClass(formFieldLabelErrorClassname);

                    }

                });

            },
            _singleton;

        // field length limitations
        FormValidation.prototype.limit = function() {

            $('[ data-parsley-rera_id ]').on('keypress.truncate', function() {
                truncateVal($(this), 5);
            });
            $('[ data-parsley-rera_id ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 5);
            });

            $('[ data-parsley-max_number ]').on('keypress.truncate', function() {
                truncateVal($(this), parseInt($(this).attr('data-max-length')));
            });
            $('[ data-parsley-max_number ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', parseInt($(this).attr('data-max-length')));
            });

            $('[ data-parsley-passportid ]').off('keypress.truncate');

            $('[ data-parsley-verification_code ], ' +
                '[ data-parsley-pobox ], ' +
                '[ data-parsley-grossfloorarea ]').on('keypress.truncate', function() {
                truncateVal($(this), 6);
            });
            $('[ data-parsley-verification_code ], ' +
                '[ data-parsley-pobox ], ' +
                '[ data-parsley-grossfloorarea ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 6);
            });

            $('[ data-parsley-telephone_number ]').on('keypress.truncate', function() {
                truncateVal($(this), 8);
            });
            $('[ data-parsley-telephone_number ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 8);
            });
            $('[ data-parsley-bpn ]').on('keypress.truncate', function() {
                truncateVal($(this), 8);
            });
            $('[ data-parsley-bpn ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 8);
            });
            $('[ data-parsley-twonum ]').on('keypress.truncate', function() {
                truncateVal($(this), 10);
            });
            $('[ data-parsley-twonum ]').on('paste.truncate', function() {

                queuePasteEvent($(this), 'truncate', 10);
            });

            $('[ data-parsley-premise_number ], ' +
                '[ data-parsley-notification_number ], ' +
                '[ data-parsley-estimate_number ], ' +
                '[ data-parsley-mobilenumber ], ' +
                '[ data-parsley-mobile_number ]').on('keypress.truncate', function() {
                truncateVal($(this), 9);
            });
            $('[ data-parsley-premise_number ], ' +
                '[ data-parsley-notification_number ], ' +
                '[ data-parsley-estimate_number ], ' +
                '[ data-parsley-mobilenumber ], ' +
                '[ data-parsley-mobile_number ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 9);
            });

            $('[ data-parsley-maxnumber ]').on('keypress.truncate', function() {
                truncateVal($(this), parseInt($(this).attr('data-parsley-maxnumber')));
            });
            $('[ data-parsley-maxnumber ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', parseInt($(this).attr('data-parsley-maxnumber')));
            });

            $('[ data-parsley-account_number ], ' +
                '[ data-parsley-account_premise_number ]').on('keypress.truncate', function() {
                truncateVal($(this), 10);
            });
            $('[ data-parsley-account_number ], ' +
                '[ data-parsley-account_premise_number ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 10);
            });
            $('[ data-parsley-emiratesid ]').on('keypress.truncate', function() {

                var attr = $(this).attr("data-parsley-emiratesid");


                if (typeof attr !== typeof undefined && attr !== false) {
                    truncateVal($(this), 15);
                }
            });
            $('[ data-parsley-emiratesid ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 15);
                //console.log('emirates')
            });
            $('[ data-parsley-passportid ]').on('keypress.truncate', function() {

                //console.log('password')
            });
            $('[ data-parsley-passportid ]').on('paste.truncate', function() {
                //console.log('password')
            });

            $('[ data-parsley-iban ], ' + '[ data-parsley-selectediban ], ' +
                '[ data-iban_confirm ]').on('keypress.truncate', function() {
                truncateVal($(this), 21);
            });

            $('[ data-parsley-doc_number ]').on('keypress.truncate', function() {
                truncateVal($(this), 35);
            });
            $('[ data-parsley-doc_number ]').on('paste.truncate', function() {
                queuePasteEvent($(this), 'truncate', 35);
            });

            // generic truncation
            $('[ data-input-truncate ]').on('keypress.truncate', function() {
                var truncateTo = parseInt($(this).data('input-truncate'), 10);
                truncateVal($(this), truncateTo);
            });
            $('[ data-input-truncate ]').on('paste.truncate', function() {
                var truncateTo = parseInt($(this).data('input-truncate'), 10);
                queuePasteEvent($(this), 'truncate', truncateTo);
            });

            // special max partial payment validation
            $('[ data-parsley-max_partial_payment ]').on('keyup', function() {
                try {
                    if ($(this).val().indexOf('.') && $(this).val().split('.')[1].length > 2) {
                        $(this).val(Math.floor(parseFloat($(this).val()) * 100) / 100);
                    }
                } catch (err) {}
            });
            $('[ data-parsley-max_partial_payment ]').on('paste.truncate', function() {
                try {
                    if ($(this).val().indexOf('.') && $(this).val().split('.')[1].length > 2) {
                        $(this).val(Math.floor(parseFloat($(this).val()) * 100) / 100);
                    }
                } catch (err) {}
            });

            // number only fields
            $(numbersOnly).on('keypress.numbers', constrainNumerals);
            $(numbersOnly).on('paste.numbers', function() {
                queuePasteEvent($(this), 'numbers');
            });

            $('[ data-parsley-passportid ]').off('keypress.numbers');
            $('[ data-parsley-passportid ]').off('paste.numbers');

            // currency input types
            $(currencyInput).on('keypress.currency', constrainCurrency);
            $(currencyInput).on('paste.currency', function() {
                queuePasteEvent($(this), 'currency');
            });

            // name input types
            $('[ data-parsley-name ]').on('keypress.name', constrainName);
            $('[ data-parsley-name ]').on('paste.name', function() {
                queuePasteEvent($(this), 'name');
            });


            // username input type
            $('[ data-parsley-username ]').on('keypress.username', constrainUsername);
            $('[ data-parsley-username ]').on('paste.username', function() {
                queuePasteEvent($(this), 'username');
            });

            // Dewa username input type
            $('[ data-parsley-dewausername ]').on('keypress.dewausername', constrainDewaUsername);
            $('[ data-parsley-dewausername ]').on('paste.dewausername', function() {
                queuePasteEvent($(this), 'dewausername');
            });

            // Dewa password input type
            $('[ data-parsley-dewapassword ]').on('paste.dewapassword', function() {
                queuePasteEvent($(this), 'dewapassword');
            });


            $()

            // paste event queue
            function queuePasteEvent(el, type, param) {

                pasteQueue[type] = param || true;

                if (!pasteRunner) {
                    pasteRunner = window.setTimeout(function() {
                        var value = el.val();

                        // run paste transforms
                        if (pasteQueue.numbers) {
                            value = pasteNumerals(value);
                        }

                        if (pasteQueue.currency) {
                            value = pasteCurrency(value);
                        }

                        if (pasteQueue.name) {
                            value = pasteName(value);
                        }

                        if (pasteQueue.username) {
                            value = pasteUsername(value);
                        }
                        if (pasteQueue.dewausername) {
                            value = pasteDewaUsername(value);
                        }

                        if (typeof pasteQueue.truncate === 'number') {
                            value = truncatePaste(value, param);
                        }

                        el.val(value);

                        resetPasteQueue();
                    }, 20);
                }
            }

            // reset queue
            function resetPasteQueue() {
                pasteQueue = [];
                pasteRunner = null;
            }

            // truncation and input rules
            function truncateVal(target, len) {
                if (target.val().length >= len) {
                    window.setTimeout(function() {
                        target.val(target.val().substring(0, (len)));
                    }, 5);
                }
            }

            function truncatePaste(value, len) {
                return value.length >= len ? value.substring(0, (len)) : value;
            }

            function constrainNumerals(ev) {
                var keyCode = ev.which,
                    character = String.fromCharCode(keyCode);

                // Allow: special keys and specifically backspace, delete, tab, escape, enter
                if (($.inArray(keyCode, [0, 8, 9, 13, 27, 190]) !== -1 && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+A
                    (character === 'a' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+C
                    (character === 'c' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+V
                    (character === 'v' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+X
                    (character === 'x' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: home, end, left, right
                    (keyCode >= 35 && keyCode <= 38 && !ev.shiftKey && !navigator.userAgent.toLowerCase().includes('iphone' || 'android' || 'ipad')) ||
                    // if allowed character
                    /[0-9]/.test(character)) {
                    return;
                }

                // prevent all others
                ev.preventDefault();
            }

            function pasteNumerals(value) {
                return value.replace(/\D/g, '');
            }

            function constrainCurrency(ev) {
                var input = $(ev.target),
                    keyCode = ev.which,
                    allowDecimal = input.val().indexOf('.') < 0 ? true : false,
                    character = String.fromCharCode(keyCode);

                // Allow: backspace, delete, tab, escape, enter
                if (($.inArray(keyCode, [0, 8, 9, 13, 27, 190]) !== -1 && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+A
                    (character === 'a' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+C
                    (character === 'c' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+V
                    (character === 'v' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+X
                    (character === 'x' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: home, end, left, right
                    (keyCode >= 35 && keyCode <= 38 && !ev.shiftKey) ||
                    // Allowed characters
                    (allowDecimal && /[\.]/.test(character) || /[0-9]/.test(character))) {

                    // prevent exceeding 2dp
                    window.setTimeout(function() {
                        if (input.val().indexOf('.') >= 0 && input.val().split('.')[1] && input.val().split('.')[1].length > 2) {
                            input.val(Math.floor(parseFloat(input.val()) * 100) / 100);
                        }
                    }, 10);

                    // allow character
                    return;
                }

                // prevent all others
                ev.preventDefault();
            }

            function pasteCurrency(value) {
                var wVal = value.replace(/[^0-9\.]+/g, ''),
                    sVal, newVal;

                wVal = wVal[0] === '.' ? '0' + wVal : wVal;
                sVal = wVal.split('.');
                newVal = sVal.length > 1 ? sVal[0] + '.' + sVal[1] : sVal[0];

                return newVal;
            }

            function constrainName(ev) {
                var keyCode = ev.which,
                    character = String.fromCharCode(keyCode);

                // Allow: backspace, delete, tab, escape, enter
                if (($.inArray(keyCode, [0, 8, 9, 13, 27, 190]) !== -1 && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+A
                    (character === 'a' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+C
                    (character === 'c' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+V
                    (character === 'v' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+X
                    (character === 'x' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: home, end, left, right
                    (keyCode >= 35 && keyCode <= 38 && !ev.shiftKey) ||
                    // Allowed characters
                    /[a-zA-Z\s'-]/.test(character)) {
                    return;
                }

                // prevent all others
                ev.preventDefault();
            }

            function pasteName(value) {
                return value.replace(/[^a-zA-Z\s'-]+/g, '');
            }


            function constrainUsername() {
                var regex = new RegExp(/[a-zA-Z0-9.@]/),
                    key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                if (!regex.test(key)) {
                    event.preventDefault();
                    return false;
                }
            }

            function pasteUsername(value) {
                return value.replace(/[^a-zA-Z0-9.@\.]+/g, '');
            }

            function constrainDewaUsername() {
                var regex = new RegExp(/[a-zA-Z0-9.]/),
                    key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                if (!regex.test(key)) {
                    event.preventDefault();
                    return false;
                }
            }

            function pasteDewaUsername(value) {
                return value.replace(/[^a-zA-Z0-9.\.]+/g, '');
            }
        };

        FormValidation.prototype.apply = function($form) {

            // on parsley triggers
            $form.find('input[type=text], input[type=file], input[type=number], input[type=email], input[type=tel]').not('[data-el=datepicker]').attr('data-parsley-trigger', 'focusout');
            $form.find('select').attr('data-parsley-trigger', 'change');

            // global parsley options
            $form.parsley({

                excluded: 'input.form-field__input--readonly, input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden'
            });

            // accessibility fix for form submission on pressing enter (not happening on the forms with multiple buttons)
            $form.find('input[type=text], input[type=number], input[type=email], input[type=tel], select').on('keydown.submit', function(event) {

                var keycode = (event.keyCode ? event.keyCode : (event.which ? event.which : event.charCode));

                if (keycode === 13) {

                    var $submit = $form.find('[type=submit]');

                    if ($submit[0] !== undefined) {

                        $submit.last().trigger('click');
                        return false;
                    }
                }
            });

            // on special validation rules for Emirates ID
            $form.find('#form-field-user_id_type').on('change.emiratesid', function() {
                var idField = $('#form-field-user_id_no'),
                    select = $(this);

                if (select.val() === 'ED') {
                    truncateVal(idField, 15);

                    idField.attr('data-parsley-emiratesid', true);
                    idField.on('keypress.eid', function() {
                        truncateVal(idField, 15);
                    });
                    idField.on('paste.eid', function() {
                        queuePasteEvent(idField, 'truncate', 15);
                    });
                } else {

                    idField.removeAttr('data-parsley-emiratesid');
                    idField.off('.eid');
                }

                window.setTimeout(function() {
                    if (idField.parsley().validationResult === true || typeof idField.parsley().validationResult === 'object' && idField.parsley().validationResult.length) {
                        idField.parsley().validate();
                    }
                }, 10);

            });

            //for international numbers
            $('.form-field--mobilenumber').each(function() {
                $(this).find('select').off('change');
            });

            function truncateVal(target, len) {
                if (target.val().length >= len) {
                    window.setTimeout(function() {
                        target.val(target.val().substring(0, (len)));
                    }, 5);
                }
            }

            // paste event queue
            function queuePasteEvent(el, type, param) {

                pasteQueue[type] = param || true;

                if (!pasteRunner) {
                    pasteRunner = window.setTimeout(function() {
                        var value = el.val();

                        if (typeof pasteQueue.truncate === 'number') {
                            value = truncatePaste(value, param);
                        }

                        el.val(value);

                        resetPasteQueue();
                    }, 20);
                }
            }

            // reset queue
            function resetPasteQueue() {
                pasteQueue = [];
                pasteRunner = null;
            }

            function truncatePaste(value, len) {
                return value.length >= len ? value.substring(0, (len)) : value;
            }

            function constrainNumerals(ev) {
                var keyCode = ev.which,
                    character = String.fromCharCode(keyCode);

                // Allow: special keys and specifically backspace, delete, tab, escape, enter
                if (($.inArray(keyCode, [0, 8, 9, 13, 27, 190]) !== -1 && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+A
                    (character === 'a' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+C
                    (character === 'c' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+V
                    (character === 'v' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: Ctrl/Cmd+X
                    (character === 'x' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
                    // Allow: home, end, left, right
                    (keyCode >= 35 && keyCode <= 38 && !ev.shiftKey) ||
                    // if allowed character
                    /[0-9]/.test(character)) {
                    return;
                }

                // prevent all others
                ev.preventDefault();
            }

            //international numbers
            $('.form-field--mobilenumber').each(function() {
                var $prefix = $(this).find('.form-field--mobilenumber_select .form-field__input--select'),
                    $input = $(this).find('.form-field--mobilenumber_text .form-field__input');

                //console.log($prefix.val())

                $input.off('keypress.const').on('keypress.const', constrainNumerals);

                if ($prefix.val() == '+971' || $prefix.val() == '00971' || $prefix.val() == '971') {
                    if ($input.attr('data-parsley-telephonenumber') == 'true') {
                        $input.attr('data-parsley-pattern', '/^(?:2|3|4|6|7|9)\u005Cd{7}$/');
                        $input.attr('maxlength','8');
                        $input.off('keypress.int').on('keypress.int', function() {
                            truncateVal($(this), 8)
                        });
                        $input.off('paste.int').on('paste.int', function() {
                            queuePasteEvent($(this), 'truncate', 8);
                        });
                    } else {
                        $input.attr('data-parsley-pattern', '/^(?:50|51|52|53|54|55|56|57|58|59|52|54|55|56)\u005Cd{7}$/');
                        $input.attr('maxlength','9');
                        $input.off('keypress.int').on('keypress.int', function() {
                            truncateVal($(this), 9)
                        });
                        $input.off('paste.int').on('paste.int', function() {
                            queuePasteEvent($(this), 'truncate', 9);
                        });
                    }
                } else {
                    $input.attr('data-parsley-pattern', '/\u005Cd/');
                    $input.attr('maxlength','20');
                    $input.off('keypress.int');
                    $input.off('paste.int');
                };

                $prefix.off('change.int').on('change.int', function() {
                    if ($prefix.val() == '+971' || $prefix.val() == '00971' || $prefix.val() == '971') {
                        if ($input.attr('data-parsley-telephonenumber') == 'true') {
                        $input.attr('data-parsley-pattern', '/^(?:2|3|4|6|7|9)\u005Cd{7}$/');
                        $input.attr('maxlength','8');
                        $input.off('keypress.int').on('keypress.int', function() {
                            truncateVal($(this), 8)
                        });
                        $input.off('paste.int').on('paste.int', function() {
                            queuePasteEvent($(this), 'truncate', 8);
                        });
                    } else {
                        $input.attr('data-parsley-pattern', '/^(?:50|51|52|53|54|55|56|57|58|59|52|54|55|56)\u005Cd{7}$/');
                        $input.attr('maxlength','9');
                        $input.off('keypress.int').on('keypress.int', function() {
                            truncateVal($(this), 9)
                        });
                        $input.off('paste.int').on('paste.int', function() {
                            queuePasteEvent($(this), 'truncate', 9);
                        });
                    }
                    } else {
                        $input.attr('data-parsley-pattern', '/\u005Cd/');
                        $input.attr('maxlength','20');
                        $input.off('keypress.int');
                        $input.off('paste.int');
                    };
                    $input.parsley().validate();
                });
            });

        };

        _singleton = new FormValidation();

        return _singleton;
    });

